import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';

interface IProps extends ICasRenderCellProps {
  entityId: number;
  onUpdated: VoidFunction;
}

export function RenderIgnoreLastTouch({
  row,
  column,
  entityId,
  onUpdated,
}: IProps) {
  const value = getCasTableCellValue({ row, column });
  const label = value ? 'Yes' : 'No';

  const { mutate } = useUpdateMutation({
    url: 'Utilities/EntityTouchpoint/UpdateIgnoreLastTouch',
    params: { id: row.id, entityId },
    onSuccess: (successData) => {
      onSuccessEnqueueSnackbar(successData);
      onUpdated();
    },
  });

  return <CasLink onClick={() => mutate({ ignoreLastTouch: !value })}>{label}</CasLink>;
}
